import { useRef, useMemo } from 'react';
import useSWR from 'swr';
import { SERVICES } from '@shared/constants/apiConfig';
import { CommunicationType } from '../interfaces';

export interface IOneClickCommunicationDataModel {
  communicationType: number;
  daysRangeBegin: number;
  daysRangeEnd: number;
  description: string;
  id: string;
  title: string | null;
  userId: string | null;
  templateId: string;
}

export const useOneClickCommunicationData = (communicationType: CommunicationType, userId: string | null) => {
  const communicationData = useRef<IOneClickCommunicationDataModel[]>([]);
  const requestArgs = useMemo(
    () => `communicationType=${communicationType}${userId ? `&userId=${userId}` : ''}`,
    [communicationType, userId],
  );

  const { data, mutate, error } = useSWR(() => `${SERVICES.LEAD}/oneclick/configuration?${requestArgs}`);

  const isLoading = !data && !error;

  if (data) {
    communicationData.current = data;
  } else {
    communicationData.current = [];
  }

  return {
    communicationData: communicationData.current,
    refetchCommunicationData: mutate,
    isLoading,
  };
};
